import * as React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router';
import { Field } from 'redux-form';
import passwordField from '../../generic/PasswordField';
import { validators } from '../../../redux/modules/utils/forms';
export default function () {
    return React.createElement('div', {
        'id': 'ChangePassword',
        'className': 'auth-page'
    }, React.createElement('div', {}, React.createElement('div', { 'className': 'logo' }, React.createElement('img', {
        'src': '/global/assets/images/logo/logo-big.png',
        'alt': 'Stan Winston School Of Character Arts'
    })), React.createElement('div', { 'className': 'change-password-box auth-form-box' }, React.createElement('h1', {}, 'Change your password'), React.createElement('form', {
        'id': 'SignInForm',
        'onSubmit': this.props.handleSubmit
    }, React.createElement(Field, {
        'name': 'oldPassword',
        'validate': validators.required,
        'component': passwordField,
        'placeholder': 'Your old password',
        'props': { ariaLabel: 'Your old password' }
    }), React.createElement('div', { 'className': 'forgot-password' }, React.createElement(Link, { 'to': '/users/password/new' }, 'Forgot password?')), React.createElement(Field, {
        'name': 'password1',
        'validate': validators.required,
        'component': passwordField,
        'placeholder': 'Your new password',
        'props': { ariaLabel: 'Your new password' }
    }), React.createElement(Field, {
        'name': 'password2',
        'validate': validators.required,
        'component': passwordField,
        'placeholder': 'Retype your new password',
        'props': { ariaLabel: 'Retype your new password' }
    }), React.createElement('button', {
        'type': 'submit',
        'className': 'btn -wide -blue-2',
        'disabled': this.props.pristine || this.props.submitting
    }, '\n          Change password\n        ')), React.createElement('div', { 'className': 'auth-alt' }, '\n        or ', React.createElement(Link, { 'to': '/login' }, 'Sign In')))));
}